import imgix from "@config/imgix"
import { ChoicesArticleCombination } from "@generated"
import { FC } from "react"
import * as S from "./ProductThumbnails.elements"

type RelatedCombinationCardProductThumbnailsProps = {
  products: ChoicesArticleCombination[]
  handleSelect: (id: string) => void
  activeProductId: string
}

export const RelatedCombinationCardProductThumbnails: FC<
  RelatedCombinationCardProductThumbnailsProps
> = ({ products, handleSelect, activeProductId }) => {
  return (
    <S.Grid>
      {products.map((product) => (
        <S.Item
          key={product.id}
          isActive={activeProductId === product.id}
          onClick={() => handleSelect(product.id)}
        >
          <S.Image
            src={imgix({
              key: product.images[0].path.replace(".png", ""),
              type: "articleCombination",
              args: {
                w: 500,
                h: 500,
              },
            })}
            alt="variant"
          />
        </S.Item>
      ))}
    </S.Grid>
  )
}
